import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
// components
import { ApplicationFormComponent } from './application-form.component';
// services
import { RouteChangeService } from '../../services/routes/routeChange.service';
import { ValidationService } from '../../services/validation/validation.service';
import { AmorphicService } from '../../services/amorphic/amorphic.service';
import { NavigationService } from '../../services/navigation/navigation.service';
import { GeoChangeService } from '../../services/geoChange/geoChange.service';
import { ParserService } from '../../../../common/angular-shared/services/parser/parser.service';
import { FormatterService } from '../../services/formatter/formatter.service';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { PredicateService } from '../../services/predicate/predicate.service';
import { ApplicationService } from '../../services/application/application.service';
import { AutofillService } from '../../services/application/autofill.service';
import { UnsupportedUseCasesService } from '../../services/unsupportedUseCases/unsupportedUseCases.service';
import { InformationModalService } from '../../services/informationModal/informationModal.service';
import { ModalService } from '../../services/modal/modal.service';
import { AMCAuth0Service } from '../../services/authentication/amc/amc-auth0.service';
//modules
import { SharedModule } from '../shared/shared.module';
import { LoadingModule } from '../shared/loading/loading.module';
import { SpinnerModule } from '../shared/spinner/spinner.module';
import { CoverpathApplicationFormModule } from './coverpath-application-forms';
import { WorkflowService } from '../../services/workflow/workflow.service';
import { PremiumLessQuoteModalModule } from '../../../../coverpath-agent/public/js/components/modals/premium-less-quote/premium-less-quote.module';
import { DesignSystemModule } from '@hit/coverpath-design-system';

const routes: Routes = [
  {
    path: '',
    component: ApplicationFormComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes), PremiumLessQuoteModalModule],
  exports: [RouterModule],
})
export class ApplicationFormModuleRouter {}

export const ApplicationFormComponents = [ApplicationFormComponent];
@NgModule({
  declarations: [ApplicationFormComponents],
  exports: [ApplicationFormComponent],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CoverpathApplicationFormModule,
    CommonModule,
    RouterModule,
    ApplicationFormModuleRouter,
    SharedModule,
    LoadingModule,
    SpinnerModule,
    DesignSystemModule,
  ],
  bootstrap: [ApplicationFormComponent],
})
export class ApplicationFormModule {
  static forRoot(): ModuleWithProviders<unknown> {
    return {
      ngModule: ApplicationFormModule,
      providers: [
        AmorphicService,
        WindowService,
        ApplicationService,
        AutofillService,
        PredicateService,
        UnsupportedUseCasesService,
        InformationModalService,
        ValidationService,
        FormatterService,
        ParserService,
        GeoChangeService,
        RouteChangeService,
        NavigationService,
        WorkflowService,
        ModalService,
        AMCAuth0Service,
      ],
    };
  }
}
